import ENV from "./ENV";
import store from "app/redux/store";

let timeHelpers = {
  msInDay: 1000 * 60 * 60 * 24,
  msInHour: 1000 * 60 * 60,
  getDayTimestamps(startAt, endAt) {
    let newestDate = new Date(startAt);
    let oldestDate = new Date(endAt);
    // console.log(newestDate, oldestDate)
    let days = [];
    let dayTimestamps = [];
    let counter = oldestDate.getTime();
    while (counter < newestDate.getTime()) {
      let newDate = new Date(counter);
      newDate.setHours(0);
      newDate.setMinutes(0);
      newDate.setSeconds(0);
      newDate.setMilliseconds(0);
      let newDateString = newDate.toDateString();
      days.push(newDateString);
      dayTimestamps.push(newDate.getTime());
      counter += timeHelpers.msInDay;
    }
    days = days.reverse();
    // dayTimestamps = dayTimestamps.reverse()
    return dayTimestamps;
  },
  getWeek(date = new Date()) {
    if (typeof date == "string" && date.length == 10)
      date = timeHelpers.dateToDateTime(date);
    let d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let dayNum = d.getDay() || 7;
    d.setDate(d.getDate() + 4 - dayNum);
    let yearStart = new Date(d.getFullYear(), 0, 1);
    return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  },
  yesterday(date = new Date()) {
    if (typeof date == "string" && date.length == 10)
      date = timeHelpers.dateToDateTime(date);
    if (typeof date == "string") date = new Date(date);
    let ts = date.getTime();
    let yesterday = new Date(ts - timeHelpers.msInDay);
    // console.log(date, yesterday);
    return yesterday;
  },
  tomorrow(date = new Date(), addDays = 1) {
    const rawDate = date;
    if (typeof date == "string") {
      if (date.length == 10) {
        // input format: "YYYY-MM-DD"
        date = timeHelpers.dateToDateTime(date);
      } else {
        date = new Date(date);
      }
    }
    let ts = date.getTime();
    let tomorrow = new Date(ts + timeHelpers.msInDay * addDays);
    // console.log("tomorrow", rawDate, date, addDays, ts, tomorrow);
    return tomorrow;
  },
  beginningOfWeek(date = new Date()) {
    if (typeof date == "string" && date.length == 10)
      date = timeHelpers.dateToDateTime(date);
    let d = new Date(date);
    let day = d.getDay();
    let diff = d.getDate() - day; // + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  },
  beginningOfDay(date = new Date()) {
    if (typeof date == "string" && date.length == 10)
      date = timeHelpers.dateToDateTime(date);
    let d = new Date(date);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return new Date(d);
  },
  endOfDay(date = new Date()) {
    if (typeof date == "string" && date.length == 10)
      date = timeHelpers.dateToDateTime(date);
    let d = new Date(date);
    let b = timeHelpers.beginningOfDay(d);
    let e = b.getTime() + timeHelpers.msInDay - 1;
    return new Date(e);
  },
  endOfWeek(date = new Date()) {
    if (typeof date == "string" && date.length == 10)
      date = timeHelpers.dateToDateTime(date);
    let d = new Date(date);
    let day = d.getDay();
    let diff = d.getDate() + (6 - day); // + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  },
  beginningOfMonth(date = null, addMonths = 0) {
    if (typeof date == "string" && date.length == 10)
      date = timeHelpers.dateToDateTime(date);
    console.log(date, addMonths);
    if (!date) date = new Date();
    if (typeof date == "string") date = timeHelpers.dateToDateTime(date);
    let month = date.getMonth() + addMonths;
    return new Date(date.getFullYear(), month, 1);
  },
  endOfMonth(date = null, addMonths = 0) {
    if (typeof date == "string" && date.length == 10)
      date = timeHelpers.dateToDateTime(date);
    if (!date) date = new Date();
    if (typeof date == "string") date = timeHelpers.dateToDateTime(date);
    let month = date.getMonth() + addMonths;
    return new Date(date.getFullYear(), month + 1, 0);
  },
  endOfYear(date = null, addYears = 0) {
    if (typeof date == "string" && date.length == 10)
      date = timeHelpers.dateToDateTime(date);
    if (!date) date = new Date();
    if (typeof date == "string") date = timeHelpers.dateToDateTime(date);
    let year = date.getFullYear() + addYears;
    return new Date(year, 11, 31);
  },
  daysApart(datetime1, datetime2 = new Date()) {
    let days = timeHelpers.daysAgo(datetime1, datetime2);
    days = Math.abs(days);
    return days;
  },
  diff(start, end, step = "day") {
    return timeHelpers.daysAgo(end, start);
  },
  daysAgo(datetime, now = null) {
    now = now || store.getState().app.datetime || new Date();
    let nowMidnight = new Date(now);
    let dtMidnight = new Date(datetime);
    dtMidnight.setHours(0, 0, 0, 0);
    nowMidnight.setHours(0, 0, 0, 0);
    let diff =
      (nowMidnight.getTime() - dtMidnight.getTime()) / timeHelpers.msInDay;
    // console.log(new Date(datetime), diff, 'days before', now)
    return diff;
  },
  hoursAgo(datetime, now = null) {
    now = now || store.getState().app.datetime || new Date();
    let dtTime = new Date(datetime).getTime();
    let nowTime = new Date(now).getTime();
    let diff = (nowTime - dtTime) / timeHelpers.msInHour;
    return diff;
  },
  wasToday(datetime, now = null) {
    let dt = now || store.getState().app.datetime || new Date();
    let midnight = dt ? new Date(dt) : new Date();
    midnight.setHours(0, 0, 0, 0);
    midnight = midnight.getTime();
    let nextMidnight = midnight + timeHelpers.msInDay;
    let timestamp = new Date(datetime).getTime();
    // return (timestamp > midnight)
    // console.log(
    //   datetime,
    //   now,
    //   midnight <= timestamp && timestamp < nextMidnight
    // );
    return midnight <= timestamp && timestamp < nextMidnight;
  },
  withinRange(
    ts,
    range = { startAt: null, endAt: null, start_at: null, end_at: null },
  ) {
    let startAt = range.startAt || range.start_at;
    let endAt = range.endAt || range.end_at;
    if (!startAt && !endAt) {
      return true;
    }
    // convert dates to utc timestamps
    if (startAt.length == 10) startAt += "T12:00:00.000Z";
    if (endAt.length == 10) endAt += "T12:00:00.000Z";

    ts = new Date(ts).getTime();
    startAt = !!startAt ? new Date(startAt).getTime() : null;
    endAt = !!endAt ? timeHelpers.endOfDay(endAt).getTime() : null;

    if (!endAt || ts < endAt) {
      if (!startAt || ts > startAt) {
        return true;
      }
    }
    return false;
  },
  daysFromNow(days, today = new Date()) {
    today.setHours(0, 0, 0, 0);
    today = today.getTime();
    let target = today + timeHelpers.msInDay * days;
    return new Date(target);
  },
  dateToDateTime(dateString = "") {
    if (!dateString) return undefined;
    // input format: "YYYY-MM-DD"
    if (
      dateString.length == 10 &&
      dateString[4] == "-" &&
      dateString[7] == "-"
    ) {
      let year = dateString.slice(0, 4);
      let month = dateString.slice(5, 7);
      let date = dateString.slice(8, 10);
      let d = new Date(year, month - 1, date, 0, 0, 0, 0);
      // let d = new Date();
      // d.setHours(0, 0, 0, 0);
      // d.setYear(year);
      // d.setDate(date);
      // d.setMonth(month - 1);
      return d;
    } else {
      // console.log(`invalid date string format- ${dateString}`);
      return undefined;
    }
  },
  dateTimeToDate(datetime = new Date()) {
    if (typeof datetime == "string") datetime = new Date(datetime);
    let year = datetime.getFullYear();
    let month = datetime.getMonth() + 1;
    if (month.toString().length == 1) month = `0${month}`;
    let date = datetime.getDate();
    if (date.toString().length == 1) date = `0${date}`;
    // console.log(`${year}-${month}-${date}`);
    return `${year}-${month}-${date}`;
    // output format: "YYYY-MM-DD"
  },
  averageTimes(datetimes) {
    let ts = datetimes.map((dt) => new Date(dt).getTime());
    const average = (array) => array.reduce((a, b) => a + b) / array.length;
    let avgTs = average(ts);
    // console.log(avgTs, datetimes);
    return timeHelpers.round(new Date(avgTs), "hour");
  },
  round(datetime = new Date(), roundTo = "hour") {
    if (roundTo == "hour") {
      datetime.setHours(
        datetime.getHours() + Math.round(datetime.getMinutes() / 60),
      );
      datetime.setMinutes(0, 0, 0);
      return datetime;
    }
    return datetime;
  },
  getDayOfWeek(datetime = new Date(), short = false) {
    if (typeof datetime == "string")
      datetime = timeHelpers.dateToDateTime(datetime);
    let longNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let shortNames = ["Sun", "Mon", "Tues", "Wed", "Thu", "Fri", "Sat"];
    let letterNames = ["S", "M", "T", "W", "Th", "F", "Sa"];
    let dayOfWeek = datetime.getDay();
    if (short) return shortNames[dayOfWeek];
    else return longNames[dayOfWeek];
  },
  getDayOfMonth(datetime = new Date()) {
    if (typeof datetime == "string")
      datetime = timeHelpers.dateToDateTime(datetime);
    return datetime.getDate();
  },
  getMonthName(datetime = new Date(), short = false) {
    if (typeof datetime == "string")
      datetime = timeHelpers.dateToDateTime(datetime);
    let longNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let shortNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let month = datetime.getMonth();
    if (short) return shortNames[month];
    else return longNames[month];
  },
  isAfter(now, then) {
    if (typeof then == "string" || typeof then == "number")
      then = new Date(then);
    if (now.getTime() > then?.getTime()) return true;
    return false;
  },
  isBefore(now, then) {
    if (typeof then == "string" || typeof then == "number")
      then = new Date(then);
    if (now.getTime() < then?.getTime()) return true;
    return false;
  },
};

export default timeHelpers;
